import cn from 'classnames';

import { IConDefaultType } from '..';
import ChristmasDark from '../../assets/eventLogo/christmas_dark.png';
import ChristmasLight from '../../assets/eventLogo/christmas_light.png';
import ChristmasTingle from '../../assets/eventLogo/christmas_tingle.png';
import HalloweenBubbleChat from '../../assets/eventLogo/halloween_bubblechat.svg';
import HalloweenTingle from '../../assets/eventLogo/halloween_tingle.svg';

export enum EventLogoIconVariant {
  APRIL_FOOLS = 'APRIL_FOOLS',
  CHRISTMAS = 'CHRISTMAS',
  CHRISTMAS_TINGLE = 'CHRISTMAS_TINGLE',
  HALLOWEEN = 'HALLOWEEN',
  HALLOWEEN_TINGLE = 'HALLOWEEN_TINGLE',
}

interface IEventLogoIconProps extends IConDefaultType {
  variant?: EventLogoIconVariant;
  width?: number;
  height?: number;
}

function EventLogoIcon({
  className,
  rotate,
  width,
  height,
  color,
  flip,
  variant = EventLogoIconVariant.CHRISTMAS,
  style,
}: IEventLogoIconProps) {
  const isDarkMode = localStorage.getItem('theme') === 'dark';

  const getLogoSrc = () => {
    switch (variant) {
      case EventLogoIconVariant.CHRISTMAS:
        return isDarkMode ? ChristmasDark : ChristmasLight;
      case EventLogoIconVariant.CHRISTMAS_TINGLE:
        return ChristmasTingle;
      case EventLogoIconVariant.HALLOWEEN:
        return HalloweenBubbleChat;
      case EventLogoIconVariant.HALLOWEEN_TINGLE:
        return HalloweenTingle;
      default:
        return null;
    }
  };

  const logoSrc = getLogoSrc();
  // 할로윈 alt 는 기본 로고(V2LogoBubbleChat·V2Logo)의 aria-label 과 같은 브랜드명이다
  const alt =
    variant === EventLogoIconVariant.HALLOWEEN
      ? 'BubbleChat'
      : variant === EventLogoIconVariant.HALLOWEEN_TINGLE
        ? 'Tingle'
        : 'Christmas Logo';

  return (
    <>
      {logoSrc && (
        <i
          className={cn('dds-icon', className, { flip })}
          style={{
            width,
            minWidth: width,
            height,
            transform: `rotate(${rotate}deg)`,
            ...style,
          }}
        >
          <img src={logoSrc} width={width} height={height} alt={alt} />
        </i>
      )}
    </>
  );
}

export default EventLogoIcon;
